<template>
  <div class="col-12">
    <b-card>
      <div slot="header">
        <strong v-text="$lang.check_change_person_identity" />
      </div>
      <LoadingSpinner :loading="loading" :text="loadingSpinnerText" />
      <b-alert :show="!loading" variant="info" class="mb-3 text-justify">
        <i class="fas fa-info-circle fa-lg mr-1" />
        <span v-text="alertText" />
      </b-alert>
      <PersonIdentityForm
        v-show="!loading"
        :item="item"
        :parentPermissions="parentPermissions"
        mode="EDIT"
        @close="close"
        @submit="submit"
      />
    </b-card>
  </div>
</template>

<script>
import PersonIdentityForm from "./../forms/PersonIdentityForm";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { pathOr } from "ramda";

export default {
  name: "edit-person-identity",
  inject: ["personIdentityRepository"],
  components: {
    PersonIdentityForm,
    LoadingSpinner,
  },
  props: {
    parentPermissions: {
      type: Array,
      default: () => [],
    },
    id: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      loadingSpinnerText: this.$lang.receiving_data,
      item: null,
    };
  },
  computed: {
    alertText() {
      return `قبل از تایید مشخصات جدید حتما داده‌های ارسالی با تصویر شناسنامه یا کارت ملی کاربر(پیوست شده در نمایه فردی کاربر) تطبیق داده شود و در صورت صحت مشخصات جدید تایید شود.`;
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    pathOr,
    close() {
      this.$emit("close");
    },
    async submit(getPayload) {
      try {
        this.loadingSpinnerText = this.$lang.sending_data;
        this.loading = true;
        const { person_main_data_status_id, reject_reason } = getPayload;
        const payload = {
          person_main_data_status_id,
          reject_reason,
        };
        const response = await this.personIdentityRepository.partial_edit(
          payload,
          this.id
        );
        this.$notify.success(response.data.message);
        this.close();
        this.$emit("getData");
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
    async fetchData() {
      try {
        this.loadingSpinnerText = this.$lang.receiving_data;
        this.loading = true;
        const response = await this.personIdentityRepository.find(this.id);
        this.item = pathOr(null, ["data", "data"], response);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

